
import { useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Gallery from './components/Gallery';
import Location from './components/Location';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useSchemaOrg, getCafeSchemaOrg, getFAQSchemaOrg, getLocalBusinessSchemaOrg } from '../../utils/seo';

export default function HomePage() {
  const cafeSchema = getCafeSchemaOrg();
  const faqSchema = getFAQSchemaOrg();
  const localBusinessSchema = getLocalBusinessSchemaOrg();

  useEffect(() => {
    // Add all schema.org structured data
    const schemas = [cafeSchema, faqSchema, localBusinessSchema];
    
    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      script.id = `schema-org-jsonld-${index}`;
      
      const existingScript = document.getElementById(`schema-org-jsonld-${index}`);
      if (existingScript) {
        existingScript.remove();
      }
      
      document.head.appendChild(script);
    });

    return () => {
      schemas.forEach((_, index) => {
        const scriptToRemove = document.getElementById(`schema-org-jsonld-${index}`);
        if (scriptToRemove) {
          scriptToRemove.remove();
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <About />
      <Menu />
      <Gallery />
      <Location />
      <Contact />
      <Footer />
    </div>
  );
}
